module.exports = __webpack_public_path__ + "static/media/Sedan.5506c81b.png";